import { render, staticRenderFns } from "./secondClassify.vue?vue&type=template&id=dd944a4c&"
import script from "./secondClassify.vue?vue&type=script&lang=js&"
export * from "./secondClassify.vue?vue&type=script&lang=js&"
import style0 from "./secondClassify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports